<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список пользователей</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Создать пользователя</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Клиент</div>
            <v-select class="select"
                v-model="picked_client"
                :items="clients"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Группа
                <sup class="color-red">*</sup>
            </div>
            <v-select class="select"
                v-model="formData.group_id"
                :items="groups"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Логин
                <sup class="color-red">*</sup>
            </label>
            <input type="text" class="form-control" placeholder="..." v-model="formData.login">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Электронная почта
                <sup class="color-red">*</sup>
            </label>
            <input type="email" class="form-control" placeholder="..." v-model="formData.email">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Номер телефона</label>
            <input type="tel" class="form-control" placeholder="..." v-model="formData.mobile_phone">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Имя пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="formData.name">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Фамилия пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="formData.surname">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Отчество пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="formData.patronymic">
        </div>
        <div class="mb-4">
            <div class="form-label">Комментарий</div>
            <textarea id="admin-comment" rows="3" class="form-control" placeholder="..." v-model="formData.comment"></textarea>
        </div>
    </div>
    <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createUser"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>
    <Alert />
</template>

<script>

import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import AdminUser from "../../../../models/AdminUser";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "AdminUsersCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String,
        route_admin_groups: String,
        route_client_search: String
    },
    data: function () {
        return {
            adminUser: new AdminUser({
                route_client_search: this.route_client_search,
                route_create: this.route_create,
                route_admin_groups: this.route_admin_groups,
            }),
            clients: [],
            picked_client: undefined,
            groups: [],
            formData: {
                'client_id': 0,
                'group_id': null,
                'login': '',
                'email': '',
                'mobile_phone': '',
                'name': '',
                'surname': '',
                'patronymic': '',
                'comment': ''
            },
        }
    },
    watch: {
        picked_client: function () {
            if (this.picked_client === undefined) {
                this.formData.client_id = 0;
            } else {
                this.formData.client_id = this.picked_client;
            }
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createUser: async function () {
            if (this.formData.email === '' || this.formData.email === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Заполните поле электронная почта!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.group_id === '' || this.formData.group_id === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберете группу!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.login === '' || this.formData.login === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Заполните поле логин!' });
                this.toggleLoading();
                return;
            }

            const response = await axios.post(this.route_create, this.formData)
                .then((response) => {
                    return response.data
                });

            if (response.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.message });
                this.toggleLoading();
                return;
            }

            if (response.status == 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: response.message });
                window.location.href = this.route_back;
            }
        },
        searchClients: async function () {
            let clients = await this.adminUser.clients();
            this.clients = clients.items;
        },
        searchGroups: async function () {
            let groups = await this.adminUser.getAdminGroups();
            this.groups = groups.items;
        },
    },
    mounted() {
        this.searchClients();
        this.searchGroups();
    }
}
</script>

<style scoped>

</style>
